import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import Alert from '@apps/components/Alert'
import {
  getSimSelectionPageContent,
  getSimSelectionSlugValue
} from '@apps/utils/simSelectionContent'

const SimPurchaseUnavailable = ({ userType = '' }) => {
  const { pageContent } = useSelector((state) => state.common.content)
  const { [APPLICATION_STATE.CURRENT_LANGUAGE]: language } = useContext(ApplicationContext)
  const haveSimPageContent = getSimSelectionPageContent(pageContent, language, userType) || {}
  const { shortTextFields } = haveSimPageContent

  const textContent = useMemo(() => {
    if (!shortTextFields) return {}
    return {
      simPurchaseUnavailableTitle:
        getSimSelectionSlugValue(shortTextFields, 'simPurchaseUnavailableTitle', userType),
      simPurchaseUnavailableMessage:
        getSimSelectionSlugValue(shortTextFields, 'simPurchaseUnavailableMessage', userType)
    }
  }, [shortTextFields, userType])

  return (
    <Alert
      header={textContent.simPurchaseUnavailableTitle}
      message={textContent?.simPurchaseUnavailableMessage}
    />
  )
}

SimPurchaseUnavailable.propTypes = {
  userType: PropTypes.string
}

export default SimPurchaseUnavailable
